/**
 * Leaderboard page — shows team rankings.
 */

import { Trophy } from "lucide-react";
import { Leaderboard } from "@/components/Leaderboard";

export function LeaderboardPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-yellow-500/10">
            <Trophy className="h-5 w-5 text-yellow-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Leaderboard</h1>
            <p className="text-sm text-muted-foreground">Top teams ranked by ELO rating</p>
          </div>
        </div>
      </div>

      <Leaderboard />
    </div>
  );
}